const isLocal = window.location.hostname === 'localhost';

const config = {
  API_BASE_URL: isLocal ? 'https://greenyellow-nightingale-241896.hostingersite.com' : 'https://greenyellow-nightingale-241896.hostingersite.com',
};

export default config;

